export { MemoizedInsightIcon } from './insight-icon';
